import { PermissaoModel } from "./permissao.model";
import { TipoAcesso } from "../enum/tipo-acesso.enum";
import { TokenModel } from "./token.model";
import { SMSConfigAuxModel } from "./sms-config-aux.model";

export class SMSModel {
    numero: string;
    mensagem: string;
    configuracao: SMSConfigAuxModel;
}



// WEBPACK FOOTER //
// ./src/app/util/model/sms-aux.model.ts